import _sfc_main from "./Slider.vue2.mjs";
/* empty css             */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "slider", staticClass: "slider", on: { "mousedown": _setup.handleMousedown } }, [_c("div", { ref: "track", staticClass: "slider-track", style: { width: _setup.valuePercentage + "%" } }), _c("div", { ref: "thumb", staticClass: "slider-thumb", class: { "slider-thumb-disabled": _vm.disabled }, style: _setup.thumbStyle })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "ad442c24"
);
const Slider = __component__.exports;
export {
  Slider as default
};
